module.exports = __webpack_public_path__ + "static/customers-love-dd8ebe1b575e721cfbfc4e0fe7cb2910.jpg";